"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../constants");

var IFrame_1 = __importDefault(require("../IFrame"));
/**
 * SoftwareHeritage layout Moment.
 * This Moment Component integrates with the Software Heritage Embed URL:
 * https://docs.softwareheritage.org/devel/swh-web/uri-scheme-misc.html#iframe-view-for-contents-and-directories
 */


var SoftwareHeritageMoment = function SoftwareHeritageMoment(props) {
  var swhid = props.swhid,
      url = props.url;
  /* eslint-disable react/jsx-props-no-spreading */

  return react_1.default.createElement(IFrame_1.default, __assign({}, props, {
    url: url || "https://archive.softwareheritage.org/embed/" + swhid
  }));
};

SoftwareHeritageMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: prop_types_1.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** SoftWare Heritage persistent IDentifier object, or
   * SWHID (see [SoftWare Heritage persistent IDentifiers](https://docs.softwareheritage.org/devel/swh-model/persistent-identifiers.html#persistent-identifiers) (SWHIDs) to learn more about its syntax) */
  swhid: prop_types_1.default.string,

  /** The full embeddable URL of the Software Heritage Content */
  url: prop_types_1.default.string
};
SoftwareHeritageMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  color: {
    background: 'linear-gradient(90deg, rgb(255 201 58) 00%, rgba(226,0,38,1) 100%)',
    text: 'white'
  },
  layout: constants_1.MomentLayout.IFrame,
  logo: 'https://upload.wikimedia.org/wikipedia/commons/9/94/Software-heritage-logo.1024px.png',
  title: 'Software Heritage Repository',
  type: constants_1.MomentType.SoftwareHeritage
});
exports.default = SoftwareHeritageMoment;